'use strict';
import React from 'react';
import LeaveDetailModal from './leaveDetailModal';

class LeaveCalDetail extends React.Component {
    constructor(props) {
        super(props);
        this.shouldModalClose = this.shouldModalClose.bind(this);
        this.handleClick = this.handleClick.bind(this);

        this.state = {
            detail: [],
            modalClose: false
        };
    }

    static defaultProps = {
        typeTxt: ["Annual Leave", "Medical Leave", "Reservist", "Childcare leave", "Unpaid leave", "Compassionate leave", "Other Leave", "Time-off", "Tele-commuting"],
        durationTxt: ["Full", "Am", "Pm"]
    }



    shouldModalClose(data) {
        this.setState({ modalClose: data });
    }

    handleClick(e) {
        let date = parseInt(e.target.getAttribute('data-date'));

        let detail = this.getDetail(date);
        this.setState({ detail: detail, modalClose: true });
    }

    isToday(date) {
        let today = new Date();
        if (this.props.year == today.getFullYear() && this.props.month == today.getMonth() && date == today.getDate()) {
            return true;
        }
        return false;
    }

    getDetail(date) {
        let len = this.props.newLeaves.length;
        let s = this.props.newLeaves;
        let detail = [];
        for (let i = 0; i < len; i++) {
            if (s[i].year == this.props.year && s[i].month == this.props.month && s[i].date == date) {
                detail = detail.concat({ leaveTxt: s[i].leaveTxt, status: s[i].status });
            }
        }
        return detail;
    }

    renderList(detail, date) {
        let len = detail.length;
        let list = [];
        for (let i = 0; i < (len <= 3 ? len : 3); i++) {
            list = list.concat(
                <div className={"lv-cal-list " + (detail[i].status == 0 ? "" : "lv-red")} key={i}>
                    {detail[i].leaveTxt}
                </div>
            )
        }
        if (len > 3) {
            list = list.concat(
                <div className="lv-cal-list lv-highlight" onClick={this.handleClick} data-date={date} key={4}>
                    and {len - 3} more
                </div>
            );
        }
        return list;
    }
    getHoliday(year, month, date) {
        let content = [];
        let isHoliday = false;
        if (this.props.holiday) {
            if (this.props.holiday.holiday) {
                let s = this.props.holiday;

                s.holiday.map((holiday, index) => {
                    if (holiday.year == year && holiday.month == month && holiday.date == date) {
                        isHoliday = true;
                        content = content.concat(
                            <div className="a-i-lt" key={index}>{holiday.title}</div>
                        );
                    }
                });
                if (s.event) {
                    s.event.map((event, index) => {
                        if (event.year == year && event.month == month && event.date == date) {
                            content = content.concat(
                                <div className="lv-e" key={"e" + index}><b>{event.title}</b></div>
                            );
                        }
                    });
                }
            }
        }

        return { content: content, isHoliday: isHoliday };
    }
    renderRow(wk) {
        let day_row = [];
        for (let dy = 0; dy < 7; dy++) {
            if (wk == 0 && dy < this.props.start_day) {
                day_row = day_row.concat(<td className="cal-dis" key={"e" + (wk * 7 + dy)}></td>);
            } else if (wk * 7 + dy + 1 - this.props.start_day > this.props.last_date) {
                day_row = day_row.concat(<td className="cal-dis" key={"e" + (wk * 7 + dy)}></td>);
            } else {
                let date = wk * 7 + dy + 1 - this.props.start_day;
                let isToday = this.isToday(date);
                let detail = [];
                let displayHoliday = this.getHoliday(this.props.year, this.props.month, date);
                detail = this.getDetail(date);

                let className;
                if (isToday) {
                    className = "cal-tdy cal-dy ";
                } else {
                    className = "cal-dy ";
                }
                if (displayHoliday.isHoliday) {
                    className += "cal-hdy";
                }
                day_row = day_row.concat(
                    <td className={className} key={date}>
                        <div className="cal-date">{date}</div>
                        {displayHoliday.content}
                        {this.renderList(detail, date)}
                    </td>
                );
            }
        }

        return (
            <tr key={"wk-" + wk}>
                {day_row}
            </tr>
        );
    }
    renderReference() {
        return (
            <ul className="lv-rf-ul">
                <li>AL = Annual Leave</li>
                <li>CL = Compassionate Leave</li>
                <li>ML = Medical Leave</li>
                <li>TO = Time-off</li>
                <li>TC = Tele-commuting</li>
                <li>RL = Reservist</li>
                <li>UP = Unpaid Leave</li>
                <li>CC = Childcare Leave</li>
            </ul>
        );

    }
    render() {

        let calender = [];
        for (let wk = 0; wk < this.props.last_wk; wk++) {
            calender = calender.concat(this.renderRow(wk));
        }

        return (
            <div className="cal-bd">
                <table className="cal-tb">
                    <thead>
                        <tr>
                            <th>Sun</th>
                            <th>Mon</th>
                            <th>Tue</th>
                            <th>Wed</th>
                            <th>Thu</th>
                            <th>Fri</th>
                            <th>Sat</th>
                        </tr>
                    </thead>
                    <tbody>
                        {calender}
                    </tbody>
                </table>
                <div className="cal-bd-list">
                    {this.renderReference()}
                </div>
                <LeaveDetailModal modalClose={this.state.modalClose}
                    shouldModalClose={this.shouldModalClose}
                    detail={this.state.detail} />
            </div>
        )

    }
}
export default LeaveCalDetail;


// WEBPACK FOOTER //
// ./app/components/leaveComponents/leaveCalDetail.js